"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg24SettingsLine = function Svg24SettingsLine(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("g", {
    opacity: 0.88,
    fill: useDefaultColors ? '#191919' : fill
  }, _react.default.createElement("path", {
    d: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"
  }), _react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.514 2.836A1 1 0 0 1 10.5 2h3a1 1 0 0 1 .986.836l.372 2.228c.619.255 1.196.59 1.718.994l2.117-.793a1 1 0 0 1 1.217.436l1.5 2.598a1 1 0 0 1-.23 1.272l-1.745 1.437a7.576 7.576 0 0 1 0 1.985l1.745 1.436a1 1 0 0 1 .23 1.272l-1.5 2.598a1 1 0 0 1-1.217.436l-2.117-.793c-.522.403-1.1.74-1.718.994l-.372 2.228A1 1 0 0 1 13.5 22h-3a1 1 0 0 1-.986-.836l-.372-2.228a7.492 7.492 0 0 1-1.718-.994l-2.117.793A1 1 0 0 1 4.09 18.3l-1.5-2.598a1 1 0 0 1 .23-1.272l1.745-1.437a7.57 7.57 0 0 1 0-1.985L2.82 9.572A1 1 0 0 1 2.59 8.3l1.5-2.598a1 1 0 0 1 1.217-.436l2.117.793a7.492 7.492 0 0 1 1.718-.994l.372-2.228zM12.653 20h-1.306l-.09-.536-.345-2.072a5.455 5.455 0 0 1-2.19-.975 5.525 5.525 0 0 1-.847-.78l-2.477.928-.653-1.13 2.04-1.68A5.47 5.47 0 0 1 6.5 12a5.56 5.56 0 0 1 .286-1.755l-2.04-1.68.652-1.13 2.477.927a5.533 5.533 0 0 1 1.937-1.41c.35-.151.718-.268 1.1-.345L11.348 4h1.306l.434 2.607a5.456 5.456 0 0 1 2.19.976c.31.23.594.491.848.78l2.477-.928.653 1.13-2.04 1.68A5.465 5.465 0 0 1 17.5 12a5.55 5.55 0 0 1-.286 1.755l2.04 1.68-.652 1.13-2.477-.927a5.525 5.525 0 0 1-1.937 1.41c-.35.151-.718.268-1.1.345L12.652 20z"
  })));
};

Svg24SettingsLine.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg24SettingsLine;
exports.default = _default;